









import store from '@/store'
import ApiClient from '@/js/api.js'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import Title from '@/views/atoms/Title.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'
import YellowButton from '@/views/atoms/YellowButton.vue'
import BackButton from '@/views/atoms/BackButton.vue'
import ManageSubTitle from '@/views/atoms/ManageSubTitle.vue'
import ManageRow from '@/views/organisms/ManageRow.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import ManageTemplate from '@/views/templates/ManageTemplate.vue'
import SendAreaForm from '@/views/templates/SendAreaForm.vue'
import Zipcode from '@/views/molecules/Zipcode.vue'

export default
  name: 'EditSender'

  components: {
    Pankuzu
    Title
    TextBox
    SelectBox
    YellowButton
    BackButton
    ManageSubTitle
    ManageRow
    ManageBase
    ManageTemplate
    Zipcode
    SendAreaForm
  }

  data: () ->
    memberData: {}
    prefList: {}
    prefID: '0'
    prefValue: ''

  computed: {
      prefectureID: () ->
        return @prefID
  }

  created: () ->
    store.dispatch('initPostParam')
    @$emit('set_color', true)
    @prefList = await store.getters.prefList
    if @.$route.query.id
      api = new ApiClient()
      data = await api.get('/member/sendplace/detail/' + @.$route.query.id)
      store.dispatch('setDetailParam', data)

  methods: {
    go_append_send: (e) ->
      @$router.push({
        path: '/mypage/add_sender'
        params:
          mode: 'mypage'
      })
    go_back: (e) ->
      url = await store.getters.backUrl
      if url
        @$router.push(url)
      else
        @$router.push('/mypage')
    search_address: (address) ->
      @prefID = address.pref_id + ''
      @prefValue = address.shiku_name + address.choiki_name
  }
